<template>
    <div class="row">
        <template v-if="!searchResults.length && searchProp !== ''">
          <h4 class="text-center w-100">{{tNoData}}</h4>
        </template>
        <template v-for="item in searchResults.length ? searchResults : itemsCategorized.length ? searchProp !== '' && !searchResults.length ? [] : itemsCategorized : searchProp === '' ? items : itemsCategorized.length && searchResults.length ? itemsCategorized : []"
                  v-if="false === checkHidden || true !== item.hidden">
            <div :key="'shopItem'+item.id"
                 class="col-12 col-sm-6 col-md-6 col-lg-4">
                <a :href="item.url">
                    <div class="wrapper-white mb-4">
                        <div v-if="item.logo" :style="{ 'background-image': `url(${item.logo})` }" class="logo wrapper-img d-flex justify-content-center align-items-center ">
                            <!--<img :src="item.logo"
                                 :alt="item.name" class="">-->
                        </div>
                        <div v-else class="wrapper-img d-flex justify-content-center align-items-center ">
                           <span>{{item.name}}</span>
                        </div>
                        <div class="p-3 description">
                            <span class="status-job -sale"
                              :style="{backgroundColor: item.badge.color}"
                              v-if="item.badge">{{item.badge.content}}</span>
                            <h5 class="name mt-3 mb-3">{{item.name}}</h5>
                            <div class="promo" v-if="item.description">
                              <span>{{ item.description }}</span>
                            </div>
                            <h6 class="more mt-3 mb-3">dowiedz się więcej</h6>
                        </div>
                    </div>
                </a>
            </div>
        </template>
        <template v-if="items.length <= hiddenCnt && false==showFirstLoader">
            <h4 class="text-center w-100">{{tNoData}}</h4>
        </template>

        <div class="loader" v-if="showLoader||showFirstLoader">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                 preserveAspectRatio="xMidYMid" class="lds-double-ring">
                <circle cx="50" cy="50"
                        fill="none"
                        stroke-linecap="round"
                        r="40"
                        :stroke="strokeColor"
                        stroke-width="4"
                        stroke-dasharray="62.83185307179586 62.83185307179586"
                        transform="rotate(107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
                <circle cx="50" cy="50"
                        :stroke="strokeColor"
                        fill="none"
                        stroke-linecap="round"
                        r="35"
                        stroke-width="4"
                        stroke-dasharray="54.97787143782138 54.97787143782138"
                        stroke-dashoffset="54.97787143782138"
                        transform="rotate(-107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;-360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
            </svg>
        </div>
    </div>
</template>

<script>
  // todo laoder na perwuju zagruzku
  // todo laoder na sortirowku
  // TODO COLOR FROM CONFIG
  import {mapActions} from 'vuex'
  import * as appConfig from '@/config/AppConfig'

  export default {
    name: 'SearchContent',
    props: {
      searchProp: {
        type: String,
        default: ''
      },
      categoryProp: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        items: [],
        itemsCategorized: [],
        searchResults: [],
        strokeColor: appConfig.SHOP_COLOR,
        tNoData: appConfig.T_NO_DATA,
        hiddenCnt: 0,
        showLoader: false,
        showFirstLoader: true,
        tWorkingHours: appConfig.T_WORKING_HOURS,
        checkHiddenValue: false
      }
    },
    computed: {
      categories () {
        return this.$store.getters.getStoreVar('categories')
      },
      selectedCategories () {
        return this.$store.getters.getStoreVar('selectedCategories')
      },
      orderBy () {
        return this.$store.getters.getStoreVar('orderBy')
      },
      str () {
        return this.$store.getters.getStoreVar('str')
      },
      checkHidden: {
        get () {
          return this.checkHiddenValue
        },
        set (val) {
          this.checkHiddenValue = val
        }
      }
    },
    watch: {
      searchProp (value) {
        this.$search(value, this.itemsCategorized.length ? this.itemsCategorized : this.items, {
          shouldSort: true,
          tokenize: true,
          threshold: 0.1,
          location: 0,
          distance: 20,
          maxPatternLength: 50,
          minMatchCharLength: 1,
          keys: ['name']
        }).then(results => {
          this.searchResults = results
        })
      },
      categoryProp (value) {
        const items = value.length ? [] : this.items
        if (value.length) {
          this.items.map(item => {
            const { categories } = item
            categories.map(category => {
              if (value.includes(category)) items.push(item)
            })
          })
        }
        this.itemsCategorized = items
      }
    },
    methods: {
      ...mapActions(['getItems', 'setStoreVar']),
      loadItems () {
        this.showLoader = true
        let itemsObject = Object.assign({}, this.$store.getters.getStoreVar('items'))
        let items = []
        Object.keys(itemsObject).map((key, index) => {
          let element = itemsObject[key]
          element.hidden = false
          items.push(element)
        })
        this.items = items
      },
      hideLoader () {
        setTimeout(() => {
          this.showLoader = false
        }, 300)
      }
    },
    created () {
      this.getItems()
        .then((response) => {
          this.loadItems()
          this.showLoader = false
          this.showFirstLoader = false
        })
    }
  }
</script>

<style scoped>
  strong {
    font-family: "Montserrat-Medium";
  }
  .loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .6);
    text-align: center;
    padding-top: 60px;
  }
  .loader svg {
    vertical-align: baseline;
    width: 100px;
    height: 100px;
    margin: auto;
  }
  .logo {
    height: 220px;
    background-position: center;
    background-size: cover;
  }
  .description {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 150px;
    flex-flow: column nowrap;
  }
  .name {
    display: flex;
    margin-top: 0 !important;
    line-height: 1.6;
  }
  .more {
    margin: 0 !important;
    display: flex;
    font-size: 12px;
    color: black;
  }
  .promo {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 40px;
    margin-bottom: 20px;
  }
  .promo span {
    max-width: 90%;
    color: #ec6723;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchContent.vue